import React, { useEffect, useState, useRef } from 'react';
import { useOktaAuth } from '@okta/okta-react';

/**
 * Handles the OAuth callback when returning from Okta.
 * Calls handleLoginRedirect() once so the SDK exchanges the code and then
 * invokes restoreOriginalUri (no duplicate handling, no reload loop).
 */
export default function OktaLoginCallback() {
  const { oktaAuth } = useOktaAuth();
  const [error, setError] = useState(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current || !oktaAuth) return;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('code') || !params.has('state')) return;

    handled.current = true;
    oktaAuth.handleLoginRedirect().catch((e) => {
      console.error('[OktaLoginCallback]', e);
      setError(e?.message || String(e));
    });
  }, [oktaAuth]);

  if (error) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center min-vh-100">
        <div className="alert alert-danger m-3">Login failed: {error}</div>
        <a href="#/" className="btn btn-primary">Back to Login</a>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Completing sign in...</span>
      </div>
      <span className="ms-2">Completing sign in...</span>
    </div>
  );
}
